export const EXTERNAL_MONITORING_SCAN_RESULTS_QUERY = '/external-monitoring/scan-results/list';
export const EXTERNAL_MONITORING_SUPPLIER_SCAN_RESULTS_QUERY =
  '/suppliers/:id/external-monitoring/scan-results/list';
export const EXTERNAL_MONITORING_ASSETS_QUERY = '/external-monitoring/assets';
export const EXTERNAL_MONITORING_SUPPLIER_ASSETS_QUERY =
  '/suppliers/:id/external-monitoring/assets';
export const ALLOWANCES_QUERY = '/allowances';
export const EXTERNAL_MONITORING_FINDINGS_QUERY = '/external-monitoring/scan-result-findings/list';
export const EXTERNAL_MONITORING_SUPPLIER_FINDINGS_QUERY =
  '/suppliers/:id/external-monitoring/scan-result-findings/list';
export const EXTERNAL_MONITORING_SUPPLIER_FINDINGS_STATS_QUERY =
  '/suppliers/:id/external-monitoring/latest-scan-result-findings/stats';
export const EXTERNAL_MONITORING_FINDINGS_STATS_QUERY =
  '/external-monitoring/latest-scan-result-findings/stats';
